import PlacedOrders from '@/pages/PlacedOrders'
export default {
    path: '',
    component: PlacedOrders,
    children: [
        {
            path: '/placed/orders',
            name: 'Placed Orders',
            component: PlacedOrders,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/placedorders.js